export class EmojiModel {
    public emoji = '';
    public label = '';
    public url = '';

    constructor(data?: any) {
        if (data) {
            this.emoji = data.emoji;
            this.label = data.label;
            this.url = data.url;

            if (!this.url) {
                this.url = 'https://cdn.jsdelivr.net/emojione/assets/png/1f600.png';
            }
        }
    }

    public static makeList(data: Array<any>) {
        const emojiList: Array<EmojiModel> = [];

        if (data?.length) {
            for (const item of data) {
                emojiList.push(new EmojiModel(item));
            }
        }

        return emojiList;
    }
}